import { skills } from 'data/bio';
import AbilityItem from '../AbilityItem';
import styles from './abilitiessection.module.scss';

const AbilitiesSection: React.FC = () => {
  return (
    <section id="abilities-section-root" className={styles.abilitiesSectionRoot}>
      <div className={styles.sectionContainer}>
        {skills.categories.map(category => (
          <AbilityItem key={category.id} category={category} />
        ))}
      </div>
    </section>
  );
};

export default AbilitiesSection;
